<script setup lang="ts">
import { computed } from 'vue'
import type { PreviewIncidentReportResponse } from '@roadfootage/api-client'
import { formatIncidentType, formatIncidentDateTime } from '@/utils/format'

const props = defineProps<{
  incident: PreviewIncidentReportResponse
}>()

const formattedDate = computed(() =>
  formatIncidentDateTime(props.incident.incidentDateTime, props.incident.incidentTimezone)
)
</script>

<template>
  <q-card class="full-height column">
    <q-card-section>
      <div class="text-subtitle1 text-weight-medium">Incident Details</div>
    </q-card-section>

    <q-separator inset />

    <q-list role="list" class="q-py-sm">
      <!-- Incident type -->
      <q-item>
        <q-item-section avatar>
          <q-icon name="mdi-alert-circle-outline" color="primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label overline>Type</q-item-label>
          <q-item-label>{{ formatIncidentType(incident.incidentReportType) }}</q-item-label>
        </q-item-section>
      </q-item>

      <!-- Date / time -->
      <q-item>
        <q-item-section avatar>
          <q-icon name="mdi-calendar-clock" color="primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label overline>Date &amp; Time</q-item-label>
          <q-item-label>{{ formattedDate }}</q-item-label>
        </q-item-section>
      </q-item>

      <!-- Address -->
      <q-item>
        <q-item-section avatar>
          <q-icon name="mdi-map-marker" color="primary" />
        </q-item-section>
        <q-item-section>
          <q-item-label overline>Location</q-item-label>
          <q-item-label>
            {{ incident.address?.formattedAddress ?? 'Location unknown' }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-card>
</template>
